var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", [_vm._v("FAQ - Häufig gestellte Fragen...")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "Sollten Sie eine Frage haben, die hier nicht aufgeführt ist, hilft Ihnen unser\n      "
      ),
      _c("a", { attrs: { href: _vm.supportUrl } }, [_vm._v("Support")]),
      _vm._v(" gerne weiter.\n    "),
    ]),
    _vm._v(" "),
    _c("br"),
    _vm._v(" "),
    _c("br"),
    _vm._v(" "),
    _vm.loading
      ? _c("div", [_vm._m(0)])
      : _c(
          "div",
          _vm._l(_vm.faqs, function (faq) {
            return _c(
              "div",
              { key: faq.id, staticClass: "card-container-faq" },
              [
                _c(
                  "div",
                  { attrs: { role: "tablist" } },
                  [
                    _c(
                      "b-card",
                      {
                        ref: "faqcontainer" + faq.id,
                        refInFor: true,
                        attrs: { "no-body": "" },
                      },
                      [
                        _c(
                          "b-card-header",
                          {
                            staticClass: "card-header-faq",
                            attrs: { "header-tag": "header", role: "tab" },
                          },
                          [
                            _c(
                              "b-btn",
                              {
                                directives: [
                                  {
                                    name: "b-toggle",
                                    rawName: "v-b-toggle",
                                    value: "faq-id-" + faq.id,
                                    expression: "'faq-id-' + faq.id",
                                  },
                                ],
                                staticClass: "btn-faq",
                                attrs: { block: "", variant: "light" },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(faq.subject) +
                                    "\n                "
                                ),
                                _c("i", { staticClass: "fa fa-arrow-down" }),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-collapse",
                          {
                            attrs: {
                              id: "faq-id-" + faq.id,
                              visible: _vm.getUrlParam("fid") == faq.id,
                              accordion: "my-accordion",
                              role: "tabpanel",
                            },
                          },
                          [
                            _c(
                              "b-card-body",
                              [
                                _c("vue-markdown", [
                                  _vm._v(_vm._s(faq.description)),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            )
          }),
          0
        ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("i", { staticClass: "fa fa-spin fa-spinner" }),
      _vm._v(" FAQs werden geladen ...\n    "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }